import script from "./FunctionPopularityTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FunctionPopularityTable.vue?vue&type=script&setup=true&lang=js"

import "./FunctionPopularityTable.vue?vue&type=style&index=0&id=42e2709a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42e2709a"]])

export default __exports__